__turbopack_context__.v({
  "svg_container": "Decorations-module__k_D4IG__svg_container",
  "svg_container__blue": "Decorations-module__k_D4IG__svg_container__blue",
  "svg_container__left": "Decorations-module__k_D4IG__svg_container__left",
});
